<template>
    
    <div class="margin-bg">
        <div class="card-shadow">
            <div>
                <p class=" page-title">
                    Inventory Stocks
                </p>
            </div>
            <div class="btn-container pt-10">
            
                <div class=" flex pr-0 gap-x-4">
                    <div class="relative">
                        <label for="search" class="border border-gray-200 rounded bg-white text-xs mx-2 px-2 py-2 absolute left-0 ml-0 -top-[90%] border-b-0"> From </label>
                        <input type="date" v-model="fromDate" class="search-input rounded">
                    </div>
                    <div class="relative">
                        <label for="search" class="border border-gray-200 rounded bg-white text-xs mx-2 px-2 py-2 absolute left-0 ml-0 -top-[90%] border-b-0"> To </label>
                        <input type="date" v-model="toDate" class="search-input rounded">
                    </div>
                    <div class="ml-2 px-2">
                        <button class="mx-1 add-btn h-8 text-[13px] font-inter" @click="searchBtnClicked">Filter</button>
                        <button class="mx-1 add-btn h-8 text-[13px] font-inter" @click="clearSearchBtnClicked">Clear</button>
                    </div>

                </div>
                <div class="flex gap-x-4">

                    <div class="w-full !text-sm" data-te-select-wrapper-ref>
                        <select data-te-select-init data-te-select-placeholder="Select Inventory" @change="selectedInventoryChanged"
                            data-te-select-filter="true" name="" id="" v-model="searchInventory" class="input-ui">
                            <option :value="inventory" v-for="(inventory, inventoryIndex) in searchInventoryList"
                                :key="inventoryIndex"> {{ inventory.name }} </option>
                        </select>
                    </div>
                    <div class="pt-1">
                        <a href="/inventory_stocks/opening" class="add-btn text-[13px]"> Add </a>
                    </div>
        
                </div>
            </div>
        </div>
        <div class="box-container-table">

            <div class="overflow-x-auto">
                <!-- <div class="inline-block min-w-full py-2 sm:px-6 lg:px-8"> -->
                <div class="table-container">
                    <table class="primary-table">
                        <thead>
                            <tr>
                                <th scope="col">
                                    #
                                </th>
                                <th scope="col">
                                    Item
                                </th>
                                <th scope="col">
                                    Batch No
                                </th>
                                <th scope="col">
                                    Opening
                                </th>
                                <th scope="col">
                                    In
                                </th>
                                <th scope="col">
                                    Out
                                </th>
                                <th scope="col">
                                    Balance
                                </th>
                                <th scope="col">
                                    Total Balance
                                </th>
                                <th scope="col">
                                    Valuation
                                </th>
                                <th scope="col">

                                </th>
                            </tr>
                        </thead>
                        <TableSkeleton
                        v-if="loading"
                        :rows="20"
                        :cols="6"
                        />
                        <tbody v-else>
                            <!-- <tr>
                                {{ balanceFormat(2010, 1000, 'kg', 'g') }}
                            </tr> -->
                            <div class="contents" v-for="(ledger, index) in inventoryLegderList" :key="index">
                                <tr>
                                    <td>
                                        <!-- {{ ++index }} -->
                                        {{ perPage ? (currentPage - 1) * perPage + index + 1 : index+1 }}
                                    </td>
                                    <td @click="isShowToggle(ledger)">
                                        {{ ledger.name }}
                                    </td>
                                    <td>
                                        {{ ledger.batch_nos }}
                                    </td>
                                    <td>
                                        <!-- {{ ledger.opening_balance }} {{ ledger.conversion_uom_name }} -->
                                        {{ balanceFormat(ledger.opening_balance, ledger.conversion, ledger.base_uom_name, ledger.conversion_uom_name) }}
                                    </td>
                                    <td>
                                        <!-- {{ ledger.in_balance }} {{ ledger.conversion_uom_name }} -->

                                        {{ balanceFormat(ledger.in_balance, ledger.conversion, ledger.base_uom_name, ledger.conversion_uom_name) }}
                                    </td>
                                    <td>
                                        <!-- {{ (ledger.out_balance).toLocaleString() }} {{ ledger.conversion_uom_name }} -->
                                        {{ balanceFormat(ledger.out_balance, ledger.conversion, ledger.base_uom_name, ledger.conversion_uom_name) }}
                                    </td>
                                    <td>
                                        <!-- {{ (ledger.closing_balance).toLocaleString() }} {{ ledger.conversion_uom_name }} -->

                                        {{ balanceFormat(ledger.closing_balance, ledger.conversion, ledger.base_uom_name, ledger.conversion_uom_name) }}
                                    </td>
                                    <td>
                                        {{ ledger.base_balance }} {{ ledger.conversion_balance }}
                                    </td>
                                    <td>
                                        {{ (ledger?.total_value)?.toLocaleString() }}
                                    </td>
                                    <td class="whitespace-nowrap px-6 py-4">
                                        <!-- <button id="edit-btn" class="pr-1" @click="transferBtnClicked(ledger, index)"
                                            data-te-toggle="modal" data-te-target="#transfer_modal">
                                            <i class="fas fa-exchange-alt"></i>
                                        </button>
                                        <button class="pl-2" @click="addDefectBtnClicked(ledger.item_id, index)"
                                        data-te-toggle="modal" data-te-target="#add_defect_modal">
                                            <i class="fas fa-exclamation-triangle"></i>
                                        </button>
                                        <button class="pl-2" @click="btnClickedAddMinimum(ledger,index)"
                                        data-te-toggle="modal" data-te-target="#add_minimum_modal">
                                            <i class="fas fa-plus"></i>
                                        </button> -->
                                    </td>
                                </tr>
                                <tr v-if="ledger.isShow" v-for="(batch,batchIndex) in ledger.ledgers" :key="batchIndex">
                                    <td colspan="2">
                                    </td>
                                    <td>
                                        {{ batch.batch_no }}
                                    </td>
                                    <td>
                                        {{ balanceFormat(batch.opening_balance, batch.conversion, batch.base_uom_name, batch.conversion_uom_name) }}
                                    </td>
                                    <td>
                                        {{ balanceFormat(batch.in_balance, batch.conversion, batch.base_uom_name, batch.conversion_uom_name) }}
                                    </td>
                                    <td>
                                        {{ balanceFormat(batch.out_balance, batch.conversion, batch.base_uom_name, batch.conversion_uom_name) }}
                                    </td>
                                    <td>
                                        {{ balanceFormat(batch.closing_balance, batch.conversion, batch.base_uom_name, batch.conversion_uom_name) }}
                                    </td>
                                    <td>
                                        <!-- {{ ledger.base_balance }} {{ ledger.conversion_balance }} -->
                                    </td>
                                    <td>
                                        {{ (batch?.total_value)?.toLocaleString() }}
                                    </td>
                                    <td class="whitespace-nowrap px-6 py-4">
                                        <button id="edit-btn" class="pr-1" @click="transferBtnClicked(batch, index, batchIndex)"
                                            data-te-toggle="modal" data-te-target="#transfer_modal">
                                            <i class="fas fa-exchange-alt"></i>
                                        </button>
                                        <button class="pl-2" @click="addDefectBtnClicked(batch.item_id, index, batchIndex)"
                                        data-te-toggle="modal" data-te-target="#add_defect_modal">
                                            <i class="fas fa-exclamation-triangle"></i>
                                        </button>
                                        <button class="pl-2" @click="btnClickedAddMinimum(batch,index, batchIndex)"
                                        data-te-toggle="modal" data-te-target="#add_minimum_modal">
                                            <i class="fas fa-plus"></i>
                                        </button>
                                    </td>
                                </tr>
                            </div>

                            <tr class=" !text-center" v-if="inventoryLegderList.length < 1 && !loading">
                                <td class="" colspan="10">
                                    No Data Here
                                </td>
                            </tr>
                            <!-- <div class="contents" > -->
                                <!-- <tr class="bg-white rounded-lg overflow-hidden shadow-lg">
                                    <td colspan="7" class=" px-6 py-4 font-medium ">
                                        &nbsp;
                                    </td>
                                    <td class=" px-6 py-4 font-medium ">
                                        {{ (totalValuation).toLocaleString() }}
                                    </td>
                                    <td class=" px-6 py-4 font-medium ">
                                        &nbsp;
                                    </td>
                                </tr> -->
                            <!-- </div> -->

                            <!-- looping end -->
                        </tbody>
                    </table>
                    <!-- pagination -->
                    <div class="flex justify-center">

                        <div v-if="totalData != 0" class=" bg-white  flex justify-center mt-5 py-3">
                            <button class="rounded px-6 py-1 border  hover:bg-slate-200"
                                :disabled="currentPage === 1" @click="getInventoryLegderList(currentPage - 1)">«</button>

                            <button class=" text-sm px-5 border">
                                Page <span @dblclick="showInput">{{ currentPage }}</span> / <span
                                    class="text-gray-400">{{
                                        lastPage }}</span>
                            </button>

                            <button class=" rounded px-6  py-1 border  hover:bg-slate-200"
                                :disabled="currentPage === lastPage" @click="getInventoryLegderList(currentPage + 1)"> »</button>
                        </div>
                    </div>
                </div>
            </div>


            <!-- Transfer Modal -->
            <div data-te-modal-init
                class="fixed left-0 top-0 z-[1055] hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
                id="transfer_modal" tabindex="-1" aria-labelledby="transfer_modalLabel" aria-hidden="true">
                <div data-te-modal-dialog-ref
                    class="pointer-events-none relative w-auto mb-12 translate-y-[-50px] opacity-0 transition-all duration-300 ease-in-out min-[576px]:mx-auto min-[576px]:mt-7 min-[576px]:max-w-[500px]">
                    <div
                        class="min-[576px]:shadow-[0_0.5rem_1rem_rgba(#000, 0.15)] pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">

                        <div class="relative  p-4">
                            <h5 class="text-xl text-center mt-2 font-medium leading-normal text-black"
                                id="create_modalLabel">
                                Transfer ( {{ ledger ? ledger.name : '' }} )
                            </h5>
                            <button type="button" id="close"
                                class="absolute top-4 right-4 focus:shadow-none focus:outline-none" data-te-modal-dismiss
                                aria-label="Close">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                    stroke="currentColor" class="h-5 w-5">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        <div class="relative px-12 py-4" data-te-modal-body-ref>

                            <div class="mb-4">
                                <label for="" class="block text-sm text-black mb-3">
                                    Source Inventory
                                </label>
                                <div class="bg-white mb-0 w-full text-sm inline-block" data-te-select-wrapper-ref>
                                    <select data-te-select-init data-te-select-placeholder="Select Source Inventory"
                                    data-te-select-filter="true" v-model="selectedSourceInventory">
                                        <option :value="sourceInventory.id" v-for="(sourceInventory, sourceInventoryIndex) in sourceInventories">
                                            {{ sourceInventory.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="mb-4">
                                <label for="" class="block text-sm text-black mb-3">
                                    Destination Inventory
                                </label>
                                <div class="bg-white mb-0 w-full text-sm inline-block" data-te-select-wrapper-ref>
                                    <select data-te-select-init data-te-select-placeholder="Select Destination Inventory"
                                    data-te-select-filter="true" v-model="selectedDestinationInventory">
                                        <option :value="destinationInventory.id" v-for="(destinationInventory, destinationInventoryIndex) in destinationInventories">
                                            {{ destinationInventory.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="mb-4">
                                <label for="" class="block text-sm text-black mb-3">
                                    Quantity
                                </label>
                                <input type="number" placeholder="Quantity" v-model="quantity" class="text-sm border border-gray-300
                                input-ui w-full bg-transparent rounded-lg focus:ring-0">
                            </div>

                            <div class="mb-4">
                                <label for="" class="block text-sm text-black mb-3">
                                    UOM
                                </label>
                                <div class="bg-white mb-0 w-full text-sm inline-block" data-te-select-wrapper-ref>
                                    <select data-te-select-init data-te-select-placeholder="Select UOM"
                                    data-te-select-filter="true" v-model="selectedUom">
                                        <option :value="uom" v-for="(uom, uomIndex) in itemUoms">
                                            {{ uom.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                        </div>
                        <div class="flex justify-center px-12 mb-6">
                            <button type="button" @click="confirmTransferBtnClicked"
                                class="add-btn focus:outline-none focus:ring-0 ">
                                Transfer
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--used/defect Modal -->
    <div data-te-modal-init
        class="fixed left-0 top-0 z-[1055] hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
        id="add_defect_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div data-te-modal-dialog-ref class="pointer-events-none relative flex min-h-[calc(100%-1rem)] w-auto translate-y-[-50px]
            items-center opacity-0 transition-all duration-300 ease-in-out min-[576px]:mx-auto min-[576px]:mt-7
            min-[576px]:min-h-[calc(100%-3.5rem)] min-[576px]:max-w-[500px]">
            <div class="min-[576px]:shadow-[0_0.5rem_1rem_rgba(#000, 0.15)] pointer-events-auto relative flex w-full flex-col
                rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none ">
                <div
                    class="flex flex-shrink-0 items-center justify-between rounded-t-md border-b-2 border-neutral-100 border-opacity-100 p-4 ">
                    <!--Modal title-->
                    <h5 class="text-xl font-medium leading-normal text-neutral-800 " id="exampleModalLabel">
                        Add Used/Defect Item
                    </h5>
                    <!--Close button-->
                    <button type="button"
                        class="box-content rounded-none border-none hover:no-underline hover:opacity-75 focus:opacity-100 focus:shadow-none focus:outline-none"
                        data-te-modal-dismiss aria-label="Close">
                        <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                            stroke-width="1.5" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <!--Modal body-->
                <div class="relative flex-auto p-4" data-te-modal-body-ref>
                    <div class="mb-4">
                        <label for="" class="block text-sm text-black mb-3">
                            Defect / Used
                        </label>
                        <div class="bg-white mb-0 w-full text-sm inline-block" data-te-select-wrapper-ref>
                            <select data-te-select-init data-te-select-placeholder="Select Type"
                            data-te-select-filter="true" v-model="type">
                                <option :value="type" v-for="(type,index) in typeList">
                                    {{ type.name }}
                                </option>
                                <!-- <option value="defect" key="defect"> Defect </option>
                                <option value="used" key="used"> Used </option> -->
                            </select>
                        </div>
                    </div>

                    <div class="mb-4">
                        <label for="" class="block text-sm text-black mb-3">
                            UOM
                        </label>
                        <div class="bg-white mb-0 w-full text-sm inline-block" data-te-select-wrapper-ref>
                            <select data-te-select-init data-te-select-placeholder="Select UOM"
                            data-te-select-filter="true" v-model="selectedUom">
                                <option :value="uom" v-for="(uom, uomIndex) in itemUoms">
                                    {{ uom.name }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="mb-4">
                        <label for="" class="block text-sm text-black mb-3">
                            Quantity
                        </label>
                        <input type="number" placeholder="Quantity" v-model="defectQuantity" class="text-sm border border-gray-300
                        input-ui w-full bg-transparent rounded-lg focus:ring-0">
                    </div>

                    <div class="mb-4">
                        <label for="" class="block text-sm text-black mb-3">
                            Remark
                        </label>
                        <textarea v-model="defectRemark" class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0"
                        name="" id="" cols="15" rows="5"></textarea>
                    </div>
                </div>

                <!--Modal footer-->
                <div class="flex flex-shrink-0 flex-wrap items-center justify-end rounded-b-md border-t-2 border-neutral-100 border-opacity-100 p-4 ">
                    <button type="button" class="inline-block px-6 pb-2 pt-2.5 text-xs focus:outline-none focus:ring-0 " data-te-modal-dismiss>
                        Close
                    </button>
                    <button @click="confirmAddDefectBtnClicked" type="button" data-te-toggle="modal" data-te-target="#add_defect_modal"
                    class="ml-1 inline-block rounded bg-blue-600 px-6 pb-2 pt-2.5 text-xs  text-white   focus:outline-none focus:ring-0 ">
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!--Check Modal -->
    <div data-te-modal-init
        class="fixed left-0 top-0 z-[1055] hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
        id="checkModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div data-te-modal-dialog-ref class="pointer-events-none relative flex min-h-[calc(100%-1rem)] w-auto translate-y-[-50px]
            items-center opacity-0 transition-all duration-300 ease-in-out min-[576px]:mx-auto min-[576px]:mt-7
            min-[576px]:min-h-[calc(100%-3.5rem)] min-[576px]:max-w-[500px]">
            <div class="min-[576px]:shadow-[0_0.5rem_1rem_rgba(#000, 0.15)] pointer-events-auto relative flex w-full flex-col
                rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none ">
                <div
                    class="flex flex-shrink-0 items-center justify-between rounded-t-md border-b-2 border-neutral-100 border-opacity-100 p-4 ">
                    <!--Modal title-->
                    <h5 class="text-xl font-medium leading-normal text-neutral-800 " id="exampleModalLabel">
                        Check Item
                    </h5>
                    <!--Close button-->
                    <button type="button"
                        class="box-content rounded-none border-none hover:no-underline hover:opacity-75 focus:opacity-100 focus:shadow-none focus:outline-none"
                        data-te-modal-dismiss aria-label="Close">
                        <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                            stroke-width="1.5" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <!--Modal body-->
                <div class="relative flex-auto p-4" data-te-modal-body-ref>
                    <p>
                        Are you sure ?
                    </p>
                </div>

                <!--Modal footer-->
                <!-- <div class="flex flex-shrink-0 flex-wrap items-center justify-end rounded-b-md border-t-2 border-neutral-100 border-opacity-100 p-4 ">
                    <button type="button" class="inline-block px-6 pb-2 pt-2.5 text-xs focus:outline-none focus:ring-0 " data-te-modal-dismiss>
                        Close
                    </button>
                    <button @click="confirmCheckPurchaseOrderItemBtnClicked" type="button" data-te-toggle="modal" data-te-target="#checkModal"
                    class="ml-1 inline-block rounded bg-blue-600 px-6 pb-2 pt-2.5 text-xs  text-white   focus:outline-none focus:ring-0 ">
                        Confirm
                    </button>
                </div> -->
            </div>
        </div>
    </div>


    <div data-te-modal-init
        class="fixed left-0 top-0 z-[1055] hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
        id="add_minimum_modal" tabindex="-1" aria-labelledby="add_minimum_modalLabel" aria-hidden="true">
        <div data-te-modal-dialog-ref
            class="pointer-events-none relative w-auto mb-12 translate-y-[-50px] opacity-0 transition-all duration-300 ease-in-out min-[576px]:mx-auto min-[576px]:mt-7 min-[576px]:max-w-[500px]">
            <div
                class="min-[576px]:shadow-[0_0.5rem_1rem_rgba(#000, 0.15)] pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
                <div class="relative flex justify-between py-2 px-6 border-b">
                    <h5 class="text-base text-center mt-2 font-semibold leading-normal font-inter"
                        id="add_minimum_modalLabel">
                        Add Minimum Holding Amount
                    </h5>
                    <button type="button" class="text-xs focus:shadow-none focus:outline-none" data-te-modal-dismiss id="close_add_minimum_modal"
                        aria-label="Close">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="h-4 w-4">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                <div class="relative px-6 py-4 border-b" data-te-modal-body-ref>
                    <div class="mb-4">
                        <label for="" class="label-form mb-3">
                            Minimum Holding Amount ( Base UOM - အကြီး )
                        </label>
                        <input type="number" placeholder="Minimum Holding Amount" min="0" v-model="base_min_amount" class="input-ui">
                    </div>
                    <div class="mb-4">
                        <label for="" class="label-form mb-3">
                            Base UOM (အကြီး)
                        </label>
                        <!-- <select name="" id="" v-model="selectedBaseUom" class="input-ui">
                            <option :value="uom" v-for="(uom, uomIndex) in itemUoms" :key="uomIndex"> {{ uom.name }}
                            </option>
                        </select> -->
                        <p class="input-ui">
                            {{ minimumLedger ? minimumLedger.base_uom_name : '' }}
                        </p>
                    </div>
                    
                    <div class="mb-4">
                        <label for="" class="label-form mb-3">
                            Minimum Holding Amount ( UOM - အသေး )
                        </label>
                        <input type="number" placeholder="Minimum Holding Amount" min="0" v-model="min_amount" class="input-ui">
                    </div>

                    <div class="mb-4">
                        <label for="" class="label-form mb-3">
                            Uom အသေး (Inventory သိမ်းဆည်း unit)
                        </label>
                        <!-- <select name="" id="" v-model="selectedUOM" class="input-ui">
                            <option :value="uom" v-for="(uom, uomIndex) in uomList" :key="uomIndex"> {{ uom.name }}
                            </option>
                        </select> -->

                        <p class="input-ui">
                            {{ minimumLedger ? minimumLedger.conversion_uom_name : '' }}
                        </p>
                    </div>
                    
                </div>
                <div class="flex justify-end gap-x-4 px-6 mb-6 pt-4">
                    <button type="button" class="cancel-btn focus:shadow-none focus:outline-none"
                    data-te-modal-dismiss aria-label="Close">
                        Cancel
                    </button>
                    <button type="button"
                    class="add-btn focus:outline-none focus:ring-0 "
                    @click="addMinimumAmount">
                        Create
                    </button>
                </div>
            </div>
        </div>
    </div>

    

</template>

<script>
import { Modal, Ripple, Select, initTE, Input } from "tw-elements";
import { getApiData, postApiData, deleteApiData } from '../../utilities/ajax-helpers';
import { mapGetters } from "vuex";
import 'tw-elements';
import TableSkeleton from "../Common/TableSkeleton.vue";

export default {
    components: {
        TableSkeleton
    },
    data() {
        return {
            inventoryLegderList: [],
            inventoryList: [],
            totalValuation: 0,
            selectedInventory: null,
            quantity: null,
            itemId: null,

            transferItem: null,
            deleteId: null,

            sourceInventories: [],
            selectedSourceInventory: null,
            destinationInventories: [],
            selectedDestinationInventory: null,

            defectItemId: null,
            defectItem: null,
            type: null,
            defectQuantity: null,
            uomList: [],
            itemUoms: [],
            selectedUom: null,
            defectRemark: null,

            fromDate: null,
            toDate: null,
            ledger:null,
            minimumLedger:null,
            base_min_amount:0,
            min_amount:0,

            // per_page: 20,
            // pageNumbers: [],
            // currentPage: 1,
            // paginationGroupsCount: 1,
            // per_group: 10,
            // groupedPageNumbers: [],
            // currentGroup: 0,
            // isFirstGroup: true,
            // isLastGroup: false,

            currentPage: 0,
            perPage: 0,
            lastPage: 0,
            totalData:0,

            searchInventoryList:[],
            searchInventory:null,
            url_inventory:'',
            url_date:'',
            
            typeList: [
                { name: 'Defect', value: 'defect'},
                { name: 'Used', value: 'used'}
            ],
            loading: true,
        };
    },
    // props: ['inventory_id'],

    methods: {
        ...mapGetters(['getToken']),

        alertValidationMessage(field) {
            this.$notify({
                title: 'Input validation',
                text: `You forgot to provide ${field}, please try again`,
                type: 'warn'
            });

        },

        async getInventoryLegderList(pageNumber) {
            this.loading = true;
            if(pageNumber){
                this.currentPage = pageNumber;
            }
            let url = `/api/inventory_ledger_list?page=` + pageNumber;
            if(this.fromDate && this.toDate){
                url = `${url}&from_date=${this.fromDate}&to_date=${this.toDate}`;
            }
            if(this.searchInventory){
                url = `${url}&${this.url_inventory}`;
            }
            const response = await getApiData({ url: url, token: this.getToken() });
            if (response.data) {
                this.loading = false;
                this.totalValuation = 0;
                this.inventoryLegderList = response.data.data;
                this.inventoryLegderList.forEach(ledger => {
                    ledger.base_balance = Math.floor(ledger.closing_balance / ledger.conversion) + ' ' + ledger.base_uom_name;
                    ledger.conversion_balance = null;
                    let conversionBalance = ledger.closing_balance % ledger.conversion;
                    if(conversionBalance > 0){
                        ledger.conversion_balance = conversionBalance + ' ' + ledger.conversion_uom_name;
                    }

                    this.totalValuation += ledger.total_value;
                });

                this.inventoryLegderList = this.inventoryLegderList.map(item => ({
                    ...item,
                    isShow: false
                }));

                this.lastPage = response.data.last_page;
                this.currentPage = pageNumber;
                this.perPage = response.data.per_page;
                this.totalData = response.data.total;
            }
        },
        isShowToggle(item) {
            // this.inventoryLegderList[index].isShow = !this.inventoryLegderList[index].isShow;
            item.isShow = !item.isShow;
        },
        async getInventoryList() {
            const response = await getApiData({ url: '/api/inventories', token: this.getToken() });
            if (response.data) {
                this.inventoryList = response.data;
            }
        },
        async getUomList() {
            let url = `/api/uoms`;
            let response = await getApiData({ url: url, token: this.getToken() });
            if (response.data) {
                this.uomList = response.data;
            }
        },
        btnClickedAddMinimum(ledger, index){
            this.base_min_amount = 0;
            this.min_amount = 0;
            this.minimumLedger = ledger;
        },
        async addMinimumAmount(){
            if(this.min_amount < 1 && this.base_min_amount < 1){
                this.alertValidationMessage(`Minimum amount`);
                return 1;
            }
            let formData = new FormData();
            formData.append('inventory_id', this.minimumLedger.inventory_id);
            // formData.append('inventory_id', this.inventory_id);/
            formData.append('item_id', this.minimumLedger.item_id);
            formData.append('base_uom_id', this.minimumLedger.base_unit_id);
            formData.append('base_uom_min_quantity', this.base_min_amount);
            formData.append('uom_id', this.minimumLedger.item_uom_id);
            formData.append('uom_min_quantity', this.min_amount);
            formData.append('conversion', this.minimumLedger.conversion);
            let url = `/api/inventory_item`;
            let response = await postApiData({url: url, form_data: formData, token: this.getToken()});
            if(response.success){
                this.$notify({
                    text: `Success`,
                    type: 'info'
                });
                this.getInventoryLegderList(1);
                document.getElementById('close_add_minimum_modal').click();
                this.base_min_amount = 0;
                this.min_amount = 0;
            }
            else{
                this.$notify({
                    text: response.message,
                    type: 'info'
                });
            }
        },
        addDefectBtnClicked(id, ledgerIndex){
            this.type = null;
            this.selectedUom = null;
            this.defectQuantity = null;
            this.defectRemark = null;
            this.$nextTick(() => {
                // now modal content is in DOM
                const el = this.$el.querySelector('[data-te-select-init]');
                if (el) {
                    const selectInstance = window.te?.Select?.getInstance(el);
                    if (selectInstance) {
                        selectInstance.setValue('');
                    }
                }
            });


            this.defectItemId = id;
            this.defectItem = this.inventoryLegderList[ledgerIndex];

            this.itemUoms = [];
            let index = this.uomList.findIndex(uom => uom.id == this.defectItem.base_unit_id);
            if(index != -1){
                let baseUom = this.uomList[index];
                this.itemUoms.push(baseUom);
            }
            index = this.uomList.findIndex(uom => uom.id == this.defectItem.item_uom_id);
            if(index != -1){
                let itemUom = this.uomList[index];
                this.itemUoms.push(itemUom);
            }
        },
        async confirmAddDefectBtnClicked(){
            if(!this.type){
                this.alertValidationMessage(`defect type`);
                return 1;
            }
            if(!this.selectedUom){
                this.alertValidationMessage(`UOM`);
                return 1;
            }
            if(!this.defectQuantity){
                this.alertValidationMessage(`quantity`);
                return 1;
            }
            let formData = new FormData();
            formData.append('item_id', this.defectItemId);
            // formData.append('inventory_id', this.inventory_id);/
            formData.append('quantity', this.defectQuantity);
            formData.append('uom_id', this.selectedUom.id);
            formData.append('type', this.type.value);
            formData.append('base_uom_id', this.defectItem.base_unit_id);
            if(this.defectRemark){
                formData.append('remark', this.defectRemark);
            }

            let url = `/api/used_defected_items`;
            let response = await postApiData({url: url, form_data: formData, token: this.getToken()});
            if(response.success){
                this.$notify({
                    text: `Success`,
                    type: 'info'
                });
            }
            else{
                this.$notify({
                    text: response.message,
                    type: 'info'
                });
            }

            this.selectedUom = null;
            this.defectItemId = null;
            this.defectRemark = null;
            this.defectQuantity = null;
            this.type = null;
            this.defectItem = null;
        },
        async transferBtnClicked(ledger, ledgerIndex, batchIndex) {
            this.selectedSourceInventory = null;
            this.selectedDestinationInventory = null;
            this.quantity = null;
            this.selectedUom = null;
            this.ledger = ledger
            this.itemId = ledger.item_id;
            this.transferItem = this.inventoryLegderList[ledgerIndex].ledgers[batchIndex];
            let url = `/api/inventory_list`;
            let response = await getApiData({ url: url, token: this.getToken() });
            if (response.data) {
                this.sourceInventories = response.data.source_inventories;
                this.destinationInventories = response.data.destination_inventories;
            }

            this.itemUoms = [];
            let index = this.uomList.findIndex(uom => uom.id == this.transferItem.base_unit_id);
            if(index != -1){
                let baseUom = this.uomList[index];
                this.itemUoms.push(baseUom);
            }
            index = this.uomList.findIndex(uom => uom.id == this.transferItem.item_uom_id);
            if(index != -1){
                let itemUom = this.uomList[index];
                this.itemUoms.push(itemUom);
            }
        },
        confirmTransferBtnClicked() {
            if (!this.selectedSourceInventory) {
                this.alertValidationMessage(`source inventory`);
                return 1;
            }
            if (!this.selectedDestinationInventory) {
                this.alertValidationMessage(`destination inventory`);
                return 1;
            }
            if (!this.quantity) {
                this.alertValidationMessage(`quantity`);
                return 1;
            }
            if(!this.selectedUom){
                this.alertValidationMessage(`UOM`);
                return 1;
            }
            this.transferInventory();
        },
        async transferInventory() {
            let formData = new FormData();
            formData.append('batch_no', this.ledger.batch_no);
            formData.append('source_inventory_id', this.selectedSourceInventory);
            formData.append('destination_inventory_id', this.selectedDestinationInventory);
            formData.append('quantity', this.quantity);
            formData.append('item_id', this.itemId);
            if(this.selectedUom.id == this.transferItem.base_unit_id){
                formData.append('type', 'base_uom');
            }
            else{
                formData.append('type', 'uom');
            }
            formData.append('uom_id', this.selectedUom.id);
            formData.append('base_uom_id', this.transferItem.base_unit_id);
            formData.append('conversion_uom_id', this.ledger.conversion_unit_id);
            formData.append('uom_conversion', this.transferItem.conversion);

            let response = await postApiData({ url: '/api/transfers', form_data: formData, token: this.getToken() });
            if (response.success) {
                // this.getInventoryLegderList(1);
                this.closeModal();
                this.clearForm();
                this.$notify({
                    text: `Success`,
                    type: 'info'
                });
                this.selectedUom = null;
                this.transferItem = null;
            }
            else {
                this.$notify({
                    text: `some errors occur`,
                    type: 'error'
                });
            }

            
        },
        async getSearchInventoryList(){
            const response = await getApiData({ url: '/api/get_inventory', token: this.getToken() });
            if (response.data) {
                this.searchInventoryList = response.data;
                this.searchInventory = response.data[0]
                if(this.searchInventory){
                    this.url_inventory = 'inventory_id=' + this.searchInventory.id
                }
                
                this.getInventoryLegderList(1);
            }
        },
        selectedInventoryChanged(){
            this.url_inventory = 'inventory_id=' + this.searchInventory.id
            this.fromDate = null;
            this.toDate = null;
            this.getInventoryLegderList(1);
        },
        searchBtnClicked(){
            // this.searchInventory = null;
            // this.url_inventory = '';
            this.getInventoryLegderList(1);
        },

        clearSearchBtnClicked(){
            this.fromDate = null;
            this.toDate = null;
            this.getInventoryLegderList(1);
            
        },

        closeModal() {
            document.getElementById("close").click();
        },

        clearForm() {
            this.selectedInventory = null,
                this.quantity = null
        },




        balanceFormat(amount, conversion, base_uom_name, uom_name) {
            if (!conversion || isNaN(amount)) return '-';
            // return Math.floor(amount / conversion) + ' ' + uom;
            let balance = Math.floor(amount / conversion);
            let base_balance = balance + '' + (balance > 0 ? base_uom_name : '');
            let conversion_balance = '';
            let conversionBalance = amount % conversion;
            if(conversionBalance > 0){
                conversion_balance = conversionBalance + '' + uom_name;
            }

            return conversion_balance ? base_balance + ' ' + conversion_balance : base_balance;
            // return amount + ' ' + conversion + ' ' + base_uom_name + ' ' + uom_name
        }
    },

    created() {
        // this.getInventoryLegderList(1);
        this.getInventoryList();
        this.getUomList();
        this.getSearchInventoryList();
    },

    mounted() {
        initTE({ Modal, Select, Ripple });
    }
}
</script>
